import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

import $ from 'jquery';

import { BoxTogglerService } from '../../../core/services/box-toggler.service';

// The value is appended to `.box-content` to find the content, so "#notes" targets `.box-content#notes`.
@Directive({
  selector : '[worBoxToggler]'
})
export class BoxTogglerDirective implements OnChanges, OnDestroy, OnInit {
  @Input() isOpen        ?: boolean;
  // A section starts closed, keeps an open start's markup and stops its click reaching the header.
  @Input() isSection      = false;
  @Input() worBoxToggler  = '';

  @Output() isOpenChange : EventEmitter<boolean> = new EventEmitter();

  private _initTimer : number  = null;
  private _isShown   : boolean = null;

  constructor (
    private boxTogglerService : BoxTogglerService,
    private elementRef        : ElementRef<HTMLElement>
  ) {}

  private _show ( isOpen : boolean, skipAnimation = false ) : void {
    if ( this._isShown === isOpen ) {
      return;
    }

    const content = this.boxTogglerService.getContentElement(this.worBoxToggler);
    const toggler = $(this.elementRef.nativeElement);

    this._isShown = isOpen;

    if ( isOpen ) {
      this.boxTogglerService.open(toggler, content, skipAnimation);
    }
    else {
      this.boxTogglerService.close(toggler, content, skipAnimation);
    }
  }

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isOpen && !changes.isOpen.firstChange && this._isShown !== null ) {
      this._show(!!this.isOpen);
    }
  }

  ngOnDestroy () : void {
    window.clearTimeout(this._initTimer);
  }

  // Waits a tick so content rendered later in the same view exists; an unbound box opens, an unbound section closes.
  ngOnInit () : void {
    this._initTimer = window.setTimeout(() => {
      if ( this.isOpen === undefined ) {
        this.isOpen = !this.isSection;
        this.isOpenChange.emit(this.isOpen);
      }

      // An open section keeps its markup as written.
      if ( this.isSection && this.isOpen ) {
        this._isShown = true;

        return;
      }

      this._show(!!this.isOpen, true);
    });
  }

  @HostListener('click', [ '$event' ])
  onClick ( event : Event ) : void {
    if ( this.isSection ) {
      event.stopPropagation();
    }

    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
    this._show(this.isOpen);
  }
}
